module.exports = __webpack_public_path__ + "static/media/QuadraticTable.259a6075.svg";